export const ScrollBarTailwindClassesDefault = `
  [&::-webkit-scrollbar-thumb]:rounded-full
  [&::-webkit-scrollbar-thumb]:bg-[#606F6A]
  [&::-webkit-scrollbar-track]:my-5
  [&::-webkit-scrollbar-track]:rounded-full
  [&::-webkit-scrollbar-track]:bg-[#D8D8D6]
  [&::-webkit-scrollbar]:h-[5px]
  [&::-webkit-scrollbar]:w-[5px]
`
